//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// autopilot-feed-status-unstarted imports
import { IProps, IState } from "./AutopilotFeedStatusFinished.d";
import { autopilotFeedStatusFinishedFragments } from "./AutopilotFeedStatusFinished.gql";
import { styles } from "../AutopilotFeedStatus.styles";
// util
import { getNextDefragText } from "@clockwise/client-commons/src/util/defrag";
// material-ui
import { Tooltip } from "@material-ui/core";
import { Assistant, CheckCircle, InfoOutlined } from "@material-ui/icons";
import withStyles from "@material-ui/core/styles/withStyles";
import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";
import pluralize from "pluralize";

//////////////////
// COMPONENT
//////////////////
class AutopilotFeedStatusFinishedCmpt extends React.Component<IProps, IState> {
  public static defaultProps = {
    isActionable: true,
  };

  static contextType = TranslationContext;
  declare context: React.ContextType<typeof TranslationContext>;

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const t = this.context;
    const { flowState, org } = this.props;

    const nextDefragTime =
      org.nextDefragTime.__typename !== "GraphEntityError" && org.nextDefragTime.millis;

    if (!nextDefragTime) {
      return null;
    }

    const encounteredError =
      !!flowState.current.errorMessage ||
      !org.tailoredDefragCardSummary ||
      (org.tailoredDefragCardSummary.__typename === "GraphEntityError" &&
        org.tailoredDefragCardSummary.statusCode !== 404);

    const meetingCount =
      org.tailoredDefragCardSummary &&
      org.tailoredDefragCardSummary.__typename !== "GraphEntityError" &&
      org.tailoredDefragCardSummary.yourEventMoves.length;

    const autopilotLocalRunText = getNextDefragText(nextDefragTime);

    let title: string | JSX.Element;
    let description: string;
    let tooltipText: string | undefined = undefined;

    if (encounteredError) {
      title = t("autopilot-status:error");
      description = "Will try again tomorrow";
      tooltipText = `Something went wrong with Autopilot.  Your schedule wasn't updated and no further action is required.`;
    } else if (!meetingCount) {
      title = t("autopilot-status:no-update");
      description = `Next run ${autopilotLocalRunText}`;
      tooltipText = `Clockwise considers a number of factors when searching for better times, and won't move a meeting unless all are satisfied.`;
    } else {
      title = "Your schedule was optimized";
      description = `${pluralize("meeting", meetingCount, true)} updated`;
    }

    const containerClass = this.props.isActionable ? "actionableContainer" : "container";

    return (
      <div onClick={this.props.onClick} className={this.props.classes[containerClass]}>
        {encounteredError ? (
          <Assistant className={this.props.classes.errorIcon} />
        ) : (
          <CheckCircle className={this.props.classes.icon} />
        )}
        <div>
          <div
            className={
              encounteredError ? this.props.classes.errorStatus : this.props.classes.status
            }
          >
            {title}
            {tooltipText ? (
              <Tooltip
                placement="top"
                title={tooltipText}
                classes={{ popper: this.props.classes.popper }}
              >
                <InfoOutlined className={this.props.classes.infoIcon} />
              </Tooltip>
            ) : null}
          </div>
          <div className={this.props.classes.description}>{description}</div>
        </div>
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const AutopilotFeedStatusFinishedStyled = withStyles(styles)(
  AutopilotFeedStatusFinishedCmpt,
);

//////////////////
// RELAY
//////////////////
export const AutopilotFeedStatusFinished = createFragmentContainer(
  AutopilotFeedStatusFinishedStyled,
  autopilotFeedStatusFinishedFragments,
);
